<template>
  <CardWithTitle
    :item-id="itemId"
    :request-status="requestStatus"
    :options-data="optionsData"
    @call-option-menu="callOptionMenu"
    @reload="getData"
  >
    <v-row
      no-gutters
      class="sac-report-calls-quantity"
      justify="center"
    >
      <v-col cols="12">
        <h2
          v-if="!showContent"
          class="pa-0 ma-0 error-container__title text-center"
        >
          {{ noPagesLabel }}
        </h2>
        <v-data-table
          v-if="showContent"
          :headers="headers"
          :items="tableData"
          disable-pagination
          :items-per-page="99"
          hide-default-footer
          flat
        >
          <template v-slot:item.status="{ item }">
            <StIcon
              icon-name="ticket-confirmation"
              :color="item.color"
              :size="20"
            />
            {{ item.status }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <template #top-right-slot>
      <Badge
        v-if="hasFilterApplied && isEditor"
        type="info"
        :tooltip="$t('components.Badge.label.tooltip.info')"
        :value="$t('components.Badge.label.icon.key')"
        :preset="true"
      />
    </template>
  </CardWithTitle>
</template>

<script>
import CardWithTitle from '@/components/cards/models/CardWithTitle';
import { mapActions } from 'vuex';
import statusModel from '@/mixins/status-model';
import proprietaryModel from '@/mixins/proprietary-model';
import cardsModel from '@/mixins/cards-model';
import exportModel from '@/mixins/export-model';
import StIcon from '@stilingue/st-icon';
import { formatNumber } from '@/utils/formatter';
import EventBus from '@/utils/event-bus';
import Badge from '@/components/Badge';

export default {
  name: 'SacReportCallsQuantity',
  components: {
    CardWithTitle,
    StIcon,
    Badge,
  },
  mixins: [
    statusModel,
    proprietaryModel,
    cardsModel,
    exportModel,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      requestStatus: 'loading',
      rawSeries: [],
    };
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t('components.SacReportCallsQuantity.label.statusHeader'),
          value: 'status',
        },
        {
          text: this.$t('components.SacReportCallsQuantity.label.transitionsHeader'),
          value: 'total',
        },
      ];
    },
    tableData() {
      return [
        'pending',
        'ignored',
        'open',
        'waiting',
        'replied',
        'finished',
      ].map(status => {
        return {
          status: this.getStatusColorAndName(status).name,
          color: this.getStatusColorAndName(status).color,
          total: this.rawSeries[`${status}_calls`] ? formatNumber(this.rawSeries[`${status}_calls`].total) : 0,
        };
      });
    },
    optionsData() {
      return this.baseCardOptions.concat(this.exportOptionsData).sort((actualOption, prevOption) => this.sortMenuOptions(actualOption, prevOption));
    },
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getPerformanceService',
    ]),
    getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }

      if (this.hasNoPagesIds) {
        this.requestStatus = 'success';

        if (options?.silentRefresh) {
          EventBus.$emit('updated', { itemId: this.itemId });
        }
        return false;
      }

      this.getPerformanceService({
        itemId: this.itemId,
        servicePath: 'reportCallsQuantity',
        serviceParams: {
          filter: this.filter,
        },
      })
        .then(response => {
          this.rawSeries = response;
          this.requestStatus = 'success';

          if (options?.silentRefresh) {
            EventBus.$emit('updated', { itemId: this.itemId });
          }
        })
        .catch(error => {
          console.error(error);
          this.requestStatus = 'error';
        });
    },
  },
};
</script>

<style scoped lang="scss">
  .sac-report-calls-quantity {
    width: 100%;
    height: 100%;
  }
</style>
